import { t } from "@lingui/macro";
import "./Footer.css";
import xIcon from "img/ic_x.svg";
import xIcon2 from "img/ic_x2.svg";
import discordIcon from "img/ic_discord.svg";
import discordIcon2 from "img/ic_discord2.svg";
import telegramIcon from "img/ic_telegram.svg";
import telegramIcon2 from "img/ic_telegram2.svg";
import githubIcon from "img/ic_github.svg";
import substackIcon from "img/ic_substack.svg";

type Link = {
  label: string;
  link: string;
  external?: boolean;
  isAppLink?: boolean;
};

type SocialLink = {
  link: string;
  name: string;
  icon: string;
};

export function getFooterLinks(isHome) {
  const FOOTER_LINKS: { home: Link[]; app: Link[] } = {
    home: [
      { label: t`Terms and Conditions`, link: "/terms-and-conditions" },
      { label: t`Referral Terms`, link: "/referral-terms" },
      { label: t`Media Kit`, link: "https://docs.gmx.io/docs/community/media-kit", external: true },
      // { label: "Jobs", link: "/jobs", isAppLink: true },
    ],
    app: [
      { label: t`Media Kit`, link: "https://docs.gmx.io/docs/community/media-kit", external: true },
      { label: t`Charts by TradingView`, link: "https://www.tradingview.com/", external: true },
      // { label: "Jobs", link: "/jobs" },
    ],
  };
  return FOOTER_LINKS[isHome ? "home" : "app"];
}

export const SOCIAL_LINKS: SocialLink[] = [
  { link: "https://t.me/GMX_IO", name: "Telegram", icon: telegramIcon2 },
  // { link: "https://gmxio.substack.com/", name: "Substack", icon: substackIcon },
  // { link: "https://github.com/gmx-io", name: "Github", icon: githubIcon },
  { link: "https://twitter.com/GMX_IO", name: "Twitter", icon: xIcon2 },
  { link: "https://discord.gg/H5PeQru3Aa", name: "Discord", icon: discordIcon2 },
];
